import React from 'react';
import Lineups from '../components/lineups/Lineups';

const LineupsPage = () => {
  // Use flexbox to fill height, remove container/mx-auto for full width
  return (
    <div className="p-4 md:p-6 flex flex-col h-[calc(100vh-theme(space.16))] overflow-hidden">
      <Lineups />
    </div>
  );
};

export default LineupsPage;
